import {
  getClient,
  getCustomer,
  getUser,
  updateUser
} from "@/modules/firestore_repo";

const state = {
  activeCustomer: 0,
  alert: null,
  customerIds: null,
  customerList: null,
  id: null,
  isAdmin: false,
  name: null
};

const getters = {
  getActiveCustomerId(state) {
    return state.customerIds instanceof Array && state.customerIds.length
      ? state.customerIds[state.activeCustomer]
      : null;
  },
  getCustomerCount(state) {
    return state.customerIds instanceof Array ? state.customerIds.length : 0;
  },
  getCustomerIds(state) {
    return state.customerIds || [];
  },
  getCustomerList(state) {
    return state.customerList || [];
  },
  getName(state, getters) {
    return state.name || (getters["user/isAdmin"] ? "Admin" : "Customer");
  },
  isAdmin(state) {
    return state.isAdmin === true;
  },
  isCustomer(state, getters) {
    return (
      state.isAdmin !== true && getters["user/getActiveCustomerId"] !== null
    );
  }
};

const actions = {
  async changeActiveCustomer({ commit, state }, { customerId }) {
    const index = state.customerIds.findIndex(id => id === customerId);
    console.assert(index > -1, "index should be greater than -1");
    commit("setActiveCustomer", index);
    await updateUser(state.id, { activeCustomer: index });
  },
  async changeEmail({ commit, state }, { email }) {
    console.assert(email.length, "email should not be empty");
    commit("setEmail", email);
    await updateUser(state.id, { email });
  },
  async fetchCustomerList({ commit, state }) {
    if (state.customerIds && state.customerIds.length) {
      const customers = new Array(state.customerIds.length);
      for (let i = 0; i < state.customerIds.length; i++) {
        customers[i] = await getCustomer(state.customerIds[i]);
        const { divisionLabel } = await getClient(customers[i].clientId);
        customers[i].divisionLabel = divisionLabel;
      }
      commit("setCustomerList", customers);
    }
  },
  async fetchUserData({ commit, dispatch }, { uid }) {
    try {
      const data = await getUser(uid);
      commit("setUserData", { ...data, uid });
      commit("setAlert", null);
    } catch (error) {
      commit("clearUserData");
      commit("setAlert", { message: error, type: "error" });
    }
    await dispatch("fetchCustomerList");
  }
};

const mutations = {
  clearUserData: state => {
    state.id = null;
    state.name = null;
    state.isAdmin = false;
    state.customerIds = null;
    state.activeCustomer = 0;
  },
  setActiveCustomer: (state, payload) => {
    state.activeCustomer = payload;
  },
  setEmail: (state, payload) => {
    state.activeCustomer = payload;
  },
  setAlert: (state, payload) => {
    state.alert = payload;
  },
  setCustomerList: (state, payload) => {
    state.customerList = payload;
  },
  setUserData: (state, payload) => {
    state.id = payload.uid || null;
    state.name = payload.name || null;
    state.isAdmin = payload.isAdmin || false;
    state.customerIds = payload.customerIds || null;
    state.activeCustomer = payload.activeCustomer || 0;
  }
};

export default {
  actions,
  getters,
  mutations,
  namespaced: true,
  state
};
